// Copyright (c) Docugami, Inc. All rights reserved.

import { ComponentId, tagComponent } from "sdv/engine/Component";
import { Entity } from "sdv/engine/Entity";

export function renderEntity(entity: Entity | null, remove: boolean = false) {
    if (remove) {
        entity?.removeComponent(ComponentId.Renderable);
    }
    else {
        entity?.ensureComponent(tagComponent(ComponentId.Renderable));
    }
}
